/**
 * @generated SignedSource<<39109f2cfcba1d0c779a25734a5aa9f8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NavItemVATReportLink_seller$data = {
  readonly " $fragmentSpreads": FragmentRefs<"NavItem_seller" | "VatReportModal_seller">;
  readonly " $fragmentType": "NavItemVATReportLink_seller";
};
export type NavItemVATReportLink_seller$key = {
  readonly " $data"?: NavItemVATReportLink_seller$data;
  readonly " $fragmentSpreads": FragmentRefs<"NavItemVATReportLink_seller">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NavItemVATReportLink_seller",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NavItem_seller"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "VatReportModal_seller"
    }
  ],
  "type": "Seller",
  "abstractKey": null
};

(node as any).hash = "c67c668fd720cca2556e9734323ae0c9";

export default node;
